import { render, staticRenderFns } from "./queue_system.vue?vue&type=template&id=7e8343f5&scoped=true"
import script from "./queue_system.vue?vue&type=script&lang=js"
export * from "./queue_system.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8343f5",
  null
  
)

export default component.exports